@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$titleColor: v.$palette-gray-900;
$borderInput: v.$palette-gray-300;
$tagsBorderActive: v.$palette-blue;
$tagsShadowActive: v.$palette-blue-light-4;

.tagsModal {
  text-align: initial;
  padding: 40px;
}

.titleModal {
  margin-bottom: 16px;
  @include t.text(18px, 22px, 600);
  color: $titleColor;
}

.inputContainer {
  position: relative;
  box-shadow: 0 0 0 1px $borderInput;
  border-radius: 3px;
  max-height: 130px;
}

.tagsActive {
  box-shadow: 0 0 0 1px $tagsBorderActive, 0 0 0 3px $tagsShadowActive !important;
}

.tags {
  cursor: text;
  padding: 2px;
}

.validationMessage {
  margin-top: 8px;
  @include t.text(14px, 22px, 400);
  color: v.$palette-red;
}

.btnContainer {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.btnCancel {
  margin-right: 8px;
}

.deleteButtonLoader {
  margin-left: 10px;
  vertical-align: middle;
}